export const APP_NAME = "customer-portal";
export const APP_VERSION = "0.0.1";

export const DB_SUBSCRIPTION_STATUS_ACTIVE = 1;
export const DB_SUBSCRIPTION_STATUS_CANCELLED = 2;
export const DB_SUBSCRIPTION_STATUS_PAUSED = 4;
export const DB_SUBSCRIPTION_STATUS_EXPIRED = 5;
export const DB_SUBSCRIPTION_STATUS_INPROGRESS = 6;

export const SUBSCRIPTION_STATUS_READABLE = {
    1: "active",
    2: "cancelled",
    4: "paused",
    5: "expired",
    6: "inprogress",
};

export const CANCELLATION_REASON_LOG_STATES = {
    PREVENTED: "PREVENTED",
    REJECTED: "REJECTED",
};

export const CANCELLATION_REASON_LOG_ACTIONS = {
    CANCEL: "CANCEL",
    DELAY: "DELAY",
    PAUSE: "PAUSE",
    SKIP_NEXT_ORDER: "SKIP_NEXT_ORDER",
    UPDATE_FREQUENCY: "UPDATE_FREQUENCY",
    CANCELLATION_OFFER: "CANCELLATION_OFFER",
    SWAP_PRODUCT: "SWAP_PRODUCT",
    KEEP_SUBSCRIPTION: "KEEP_SUBSCRIPTION",
    REDEEM_LOYALTY_POINTS: "REDEEM_LOYALTY_POINTS",
    RESCHEDULE: "RESCHEDULE",
    CUSTOM: "CUSTOM",
};

export const DB_ORDER_STATUS_SUCCESS = 1;
export const DB_ORDER_STATUS_UNPROCESSED = 2;
export const DB_ORDER_STATUS_SKIPPED = 3;
export const DB_ORDER_STATUS_FAILED = 4;
export const DB_ORDER_STATUS_PROCESSING = 5;

export const ORDER_STATUS_READABLE = {
    1: "paid",
    2: "scheduled",
    3: "skipped",
    4: "failed",
    5: "processing",
};

export const CURRENCY_SYMBOLS = {
    USD: "$", // US Dollar
    EUR: "€", // Euro
    GBP: "£", // British Pound Sterling
    JPY: "¥", // Japanese Yen
    AUD: "A$", // Australian Dollar
    CAD: "CA$", // Canadian Dollar
    CHF: "CHF ", // Swiss Franc
    HKD: "HK$", // Hong Kong Dollar
    NZD: "NZ$", // New Zealand Dollar
    SEK: "kr", // Swedish Krona
    NOK: "kr ", // Norwegian Krone
    DKK: "kr  ", // Danish Krone
    ISK: "kr   ", // Icelandic Króna
    KRW: "₩", // South Korean Won
    SGD: "S$", // Singapore Dollar
    MXN: "$", // Mexican Peso
    INR: "₹", // Indian Rupee
    RUB: "₽", // Russian Ruble
    ZAR: "R", // South African Rand
    TRY: "₺", // Turkish Lira
    BRL: "R$", // Brazilian Real
    TWD: "NT$", // New Taiwan Dollar
    PLN: "zł", // Polish Zloty
    THB: "฿", // Thai Baht
    ILS: "₪", // Israeli New Shekel
    CRC: "₡", // Costa Rican Colón
    NGN: "₦", // Nigerian Naira
    PHP: "₱", // Philippine Peso
    PYG: "₲", // Paraguayan Guarani
    UAH: "₴", // Ukrainian Hryvnia
    VND: "₫", // Vietnamese Dong
    SAR: "﷼", // Saudi Riyal
    EGP: "E£", // Egyptian Pound
    MYR: "RM", // Malaysian Ringgit
    AED: "AED", // UAE Dirham
    CNY: "¥ ", // Chinese Yuan
    CZK: "Kč", // Czech Republic Koruna
    IDR: "Rp", // Indonesian Rupiah
    PKR: "₨", // Pakistani Rupee
    ARS: "$ ", // Argentine Peso
    CLP: "$  ", // Chilean Peso
    COP: "$   ", // Colombian Peso
    PEN: "S/", // Peruvian Sol
    KWD: "د.ك", // Kuwaiti Dinar
    BHD: ".د.ب", // Bahraini Dinar
    OMR: "ر.ع.", // Omani Rial
    QAR: "ر.ق", // Qatari Riyal
    RON: "lei", // Romanian Leu
    BGN: "лв", // Bulgarian Lev
    HUF: "Ft", // Hungarian Forint
    HRK: "kn", // Croatian Kuna
    KZT: "₸", // Kazakhstani Tenge
    AZN: "₼", // Azerbaijani Manat
    GEL: "₾", // Georgian Lari
    AMD: "֏", // Armenian Dram
    BYN: "Br", // Belarusian Ruble
    UZS: "UZS", // Uzbekistani Som
    TJS: "TJS", // Tajikistani Somoni
    TMT: "TMT", // Turkmenistani Manat
    MDL: "MDL", // Moldovan Leu
    MNT: "₮", // Mongolian Tugrik
    RSD: "RSD", // Serbian Dinar
    MVR: "MVR", // Maldivian Rufiyaa
    FJD: "FJ$", // Fijian Dollar
    LKR: "Rs", // Sri Lankan Rupee
    MAD: "MAD", // Moroccan Dirham
    TZS: "TSh", // Tanzanian Shilling
    KES: "KSh", // Kenyan Shilling
    KYD: "KY$", // Cayman Islands Dollar
    MUR: "₨ ", // Mauritian Rupee
    GTQ: "Q", // Guatemalan Quetzal
    BND: "B$", // Brunei Dollar
    BWP: "P", // Botswanan Pula
    DOP: "RD$", // Dominican Peso
    ALL: "L", // Albanian Lek
    DZD: "DA", // Algerian Dinar
    TTD: "TT$", // Trinidad and Tobago Dollar
    XPF: "₣", // CFP Franc
    BAM: "KM", // Bosnia and Herzegovina Convertible Mark
    MOP: "MOP$", // Macanese Pataca
    NAD: "N$", // Namibian Dollar
    KHR: "៛", // Cambodian Riel
    HNL: "L", // Honduran Lempira
    XOF: "CFA", // West African CFA Franc
    AWG: "Afl.", // Aruban Florin
    PGK: "K", // Papua New Guinean Kina
    BBD: "Bds$", // Barbadian Dollar
    CDF: "FC", // Congolese Franc
    WST: "WS$", // Samoan Tālā
    UGX: "USh", // Ugandan Shilling
    UYU: "$U", // Uruguayan Peso
    KGS: "som", // Kyrgyzstani Som
    MWK: "MK", // Malawian Kwacha
    BDT: "৳", // Bangladeshi Taka
    MKD: "ден", // Macedonian Denar
    XAF: "FCFA", // Central African CFA Franc
    GMD: "D", // Gambian Dalasi
    LBP: "L£", // Lebanese Pound
    AFN: "؋", // Afghan Afghani
    GYD: "G$", // Guyanese Dollar
    RWF: "R₣", // Rwandan Franc
    ANG: "ƒ", // Netherlands Antillean Guilder
    FKP: "£ ", // Falkland Islands Pound
    TOP: "T$", // Tongan Paʻanga
    NPR: "₨  ", // Nepalese Rupee
    MMK: "K ", // Myanmar Kyat
    BOB: "Bs.", // Bolivian Boliviano
    BSD: "B$ ", // Bahamian Dollar
    XCD: "EC$", // East Caribbean Dollar
    JMD: "J$", // Jamaican Dollar
};

export const SYMBOL_TO_CODES = {
    $: "USD",
    "€": "EUR",
    "£": "GBP",
    "¥": "JPY",
    A$: "AUD",
    CA$: "CAD",
    CHF: "CHF",
    HK$: "HKD",
    NZ$: "NZD",
    "CHF ": "CHF",
    kr: "SEK",
    "kr ": "NOK",
    "kr  ": "DKK",
    "kr   ": "ISK",
    "₩": "KRW",
    S$: "SGD",
    NT$: "TWD",
    R: "ZAR",
    "₺": "TRY",
    R$: "BRL",
    "₹": "INR",
    zł: "PLN",
    "฿": "THB",
    "₽": "RUB",
    "₪": "ILS",
    "₡": "CRC",
    "₦": "NGN",
    "₱": "PHP",
    "₲": "PYG",
    "₴": "UAH",
    "₫": "VND",
    "﷼": "SAR",
    "E£": "EGP",
    RM: "MYR",
    AED: "AED",
    "¥ ": "CNY",
    Kč: "CZK",
    Rp: "IDR",
    "₨": "PKR",
    "$ ": "ARS",
    "$  ": "CLP",
    "$   ": "COP",
    "S/": "PEN",
    "د.ك": "KWD",
    ".د.ب": "BHD",
    "ر.ع.": "OMR",
    "ر.ق": "QAR",
    lei: "RON",
    лв: "BGN",
    Ft: "HUF",
    kn: "HRK",
    "₸": "KZT",
    "₼": "AZN",
    "₾": "GEL",
    "֏": "AMD",
    Br: "BYN",
    UZS: "UZS",
    TJS: "TJS",
    TMT: "TMT",
    MDL: "MDL",
    "₮": "MNT",
    RSD: "RSD",
    MVR: "MVR",
    FJ$: "FJD",
    Rs: "LKR",
    MAD: "MAD",
    TSh: "TZS",
    KSh: "KES",
    KY$: "KYD",
    "₨ ": "MUR",
    Q: "GTQ",
    B$: "BND",
    P: "BWP",
    RD$: "DOP",
    L: "HNL",
    CFA: "XOF",
    "Afl.": "AWG",
    K: "PGK",
    Bds$: "BBD",
    FC: "CDF",
    WS$: "WST",
    USh: "UGX",
    $U: "UYU",
    som: "KGS",
    MK: "MWK",
    "৳": "BDT",
    ден: "MKD",
    FCFA: "XAF",
    D: "GMD",
    "L£": "LBP",
    "؋": "AFN",
    G$: "GYD",
    "R₣": "RWF",
    ƒ: "ANG",
    "£ ": "FKP",
    T$: "TOP",
    "₨  ": "NPR",
    "K ": "MMK",
    "Bs.": "BOB",
    "B$ ": "BSD",
    EC$: "XCD",
    J$: "JMD",
    MOP$: "MOP",
    "₣": "XPF",
};

export const BaseShopifyShippingAddress = {
    firstName: "",
    lastName: "",
    address1: "",
    address2: "",
    phone: "",
    company: "",
    city: "",
    zip: "",
    countryCode: "",
    provinceCode: "",
};

export const RDP_CSS = `
:root {
  --rdp-cell-size: 3em;
  --rdp-accent-color: #000000;
  --rdp-background-color: #000;
  --rdp-hover-text-color: #ffffff;
  --rdp-accent-color-dark: #000000;
  --rdp-background-color-dark: #fff;
  --rdp-outline: 2px solid var(--rdp-accent-color);
  --rdp-outline-selected: 2px solid rgba(0, 0, 0, 0.75);
}
.rdp-button:hover:not([disabled]) {
  background-color: var(--rdp-background-color);
  color: var(--rdp-hover-text-color);
}

.rdp-button:hover:not([disabled]) span {
  color: var(--rdp-hover-text-color);
}

.rdp-day_selected span {
  color: var(--rdp-hover-text-color);
}
`;

export const ROUTES_REGEX_LIST = [
    /customer\/[0-9]+\/addPayment$/,
    /customer\/[0-9]+\/subscription\/[0-9]+\/payment$/,
    /customer\/[0-9]+\/subscription\/[0-9]+$/,
    /customer\/[0-9]+\/gift\/[0-9]+$/,
    /customer\/[0-9]+$/,
    /login$/,
    /get-subscription-link$/,
];

export const customerBasedVariables = ["customer_first_name", "customer_last_name", "customer_email"];

export const storeBasedVariables = ["store_url", "store_name", "store_address", "store_support_email"];

export const subscriptionBasedVariables = [
    "subscription_discount",
    "subscription_total_line_item_price",
    "subscription_total_product_discount",
    "subscription_total_line_item_discounted_price",
    "subscription_shipping_price",
    "subscription_total_price",
    "subscription_next_billing_date",
    "subscription_charge_offset",
    "subscription_next_delivery_date",
    "subscription_billing_interval",
    "subscription_spent",
    "subscription_order_count",
];

export const FEATURE_SWITCHES = {
    PREPAIDV2_SELLING_PLAN_GROUPS: "PREPAIDV2_SELLING_PLAN_GROUPS",
    PREPAIDV2_CONDITION_SELLING_PLANS: "PREPAIDV2_CONDITION_SELLING_PLANS",
    PREPAIDV2_SWAP_PRODUCT: "PREPAIDV2_SWAP_PRODUCT",
    PREPAIDV2_UPDATE_FREQUENCY: "PREPAIDV2_UPDATE_FREQUENCY",
    PREPAID_V2_CANCELLATION_OFFER: "PREPAID_V2_CANCELLATION_OFFER",
    PREPAIDV2_MERGE_CONTRACT: "PREPAIDV2_MERGE_CONTRACT",
    PREPAIDV2_UPDATE_ADDRESS: "PREPAIDV2_UPDATE_ADDRESS",
    PREPAIDV2_CANCELLATION_OFFER: "PREPAIDV2_CANCELLATION_OFFER",
    CUSTOM_PAYMENT_PAGE: "CUSTOM_PAYMENT_PAGE",
    STREAKS: "STREAKS",
};

export const EVENT_TYPES = {
    ADD_AS_ONE_TIME: "loopAddAsOneTime",
    ADD_AS_SUBSCRIPTION: "loopAddAsSubscription",
    REMOVE_FOR_ONE_TIME: "loopRemoveForOneTime",
    REMOVE_FROM_SUBSCRIPTION: "loopRemoveFromSubscription",
    PRODUCT_SWAP: "loopProductSwap",
    UPDATE_PRODUCT_QUANTITY: "loopUpdateProductQuantity",
    ADD_DISCOUNT: "loopAddDiscount",
    REMOVE_DISCOUNT: "loopRemoveDiscount",
    CHANGE_SUBSCRIPTION_PLAN: "loopChangeSubscriptionPlan",
    CHANGE_DELIVERY_METHOD_REQUESTED: "loopChangeDeliveryMethodRequested",
    UPDATE_PAYMENT_METHOD_REQUESTED: "loopUpdatePaymentMethodRequested",
    EDIT_DELIVERY_DETAILS: "loopEditDeliveryDetails",
    CANCEL_SUBSCRIPTION: "loopCancelSubscription",
    REACTIVATE_SUBSCRIPTION: "loopReactivateSubscription",
    PAUSE_SUBSCRIPTION: "loopPauseSubscription",
    RESUME_SUBSCRIPTION: "loopResumeSubscription",
    ORDER_NOW: "loopOrderNow",
    SKIP_NEXT_SCHEDULED_ORDER: "loopSkipNextScheduledOrder",
    SKIP_FUTURE_SCHEDULED_ORDER: "loopSkipFutureScheduledOrder",
    UNSKIP_ORDER: "loopUnskipOrder",
    RESCHEDULE_NEXT_ORDER: "loopRescheduleNextOrder",
    DELAY_NEXT_ORDER: "loopDelayNextOrder",
    BUNDLE_ADD_AS_ONE_TIME: "loopBundleAddAsOneTime",
    BUNDLE_ADD_AS_SUBSCRIPTION: "loopBundleAddAsSubscription",
    BUNDLE_REMOVE_FOR_ONE_TIME: "loopBundleRemoveForOneTime",
    BUNDLE_REMOVE_FROM_SUBSCRIPTION: "loopBundleRemoveFromSubscription",
    BUNDLE_VARIANT_CHANGE: "loopBundleVariantChange",
    PRESET_UPDATE_PRODUCT_QUANTITY: "loopPresetBundleUpdateQuantity",
};

// BYOB Bundle Events
export const BYOB_BUNDLE_EVENTS = {
    BUNDLE_EDITED: "bundle_edited",
    BUNDLE_ADD_AS_ONE_TIME_EVENT: "bundle_add_as_one_time",
    BUNDLE_ADD_AS_SUBSCRIPTION_EVENT: "bundle_add_as_subscription",
    BUNDLE_VARIANT_CHANGE_EVENT: "bundle_variant_change",
};

// Transformation Types
export const TRANSFORMATION_TYPES = {
    TITLE: "title",
    VARIANT: "variant",
};

export const paymentMethodImage = Object.freeze({
    paypal: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/paypal-express--XwN1he2Bl3G.svg",
    shoppay: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/shop-pay-BXFIrczgXY-c.svg",
    americanexpress:
        "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/american-express-C5u3GtBWzgsC.svg",
    discover: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/discover-BV9fGXxjUnzR.svg",
    visa: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/visa-DxUoA7kmA-Jc.svg",
    mastercard: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mastercard-CTGikZxOFT4y.svg",
    bogus: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bogus-CIsYlO1zAqPE.svg",
    maestro: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/maestro-CWRaJ3hXtJ4L.svg",
    unionpay: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/unionpay-BQUSQqcIKgHx.svg",
    jcb: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/jcb-Dr6oHwV4Fzzq.svg",
    dinersclub: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/diners-club-AnBRedOkpZlg.svg",
    others: "https://www.flaticon.com/svg/vstatic/svg/3916/3916663.svg?token=exp=1715946484~hmac=f0e31dd1a39a6581c1546872842f0880",
});

export const addUpdateCardShopifyErrorsMap = {
    cp_card_failure_message_card_declined: "The card was declined.",
    cp_card_failure_message_generic_error: "An error occured.",
    cp_card_failure_message_card_expired: "The card is expired.",
    cp_card_failure_message_invalid_card_number: "The card's number is invalid.",
    cp_card_failure_message_invalid_cvv: "The card's verification value is incorrect.",
    cp_card_failure_message_already_taken: "has already been taken",
    cp_card_failure_message_invalid_cvv_generic: "The card's verification value is invalid.",
    cp_card_failure_message_invalid_zip_code: "The address's zip code is incorrect.",
    cp_card_failure_message_unsupported_card_brand: "The card's brand is not supported.",
    cp_card_failure_message_field_cannot_be_blank: "can't be blank",
    cp_card_failure_message_invalid_zip: "Payment instrument zip is not valid",
    cp_card_failure_message_city_cannot_be_blank: "Payment instrument city can't be blank",
    cp_card_failure_message_invalid_card_name: "The card's name is invalid.",
    cp_card_failure_message_address1_cannot_be_blank: "Payment instrument address1 can't be blank",
    cp_card_failure_message_invalid_card_month: "The card's month is invalid.",
    cp_card_failure_message_missing_first_name: "The card's first name is missing.",
};

export const CardUpdateEvents = {
    Success: "card_update_success",
    AttemptedButCancelled: "card_update_attempted_but_cancelled",
    Cancel: "card_update_cancel",
};

export const CardAddEvents = {
    Success: "card_add_success",
    AttemptedButCancelled: "card_add_attempted_but_cancelled",
    Cancel: "card_add_cancel",
};

export const SUBSCRIPTION_UPGRADE_PROFILE_LOG_VIEW_TYPE = {
    bannerView: "BANNER_VIEW",
    detailedView: "DETAILED_VIEW",
    allOffersView: "AlL_OFFERS_VIEW",
    dismissed: "DISMISSED",
    converted: "CONVERTED",
};

//********* cancellation flow ***************

export enum CancellationFlowEventType {
    Benefit = "BENEFIT",
    Reason = "REASON",
    Offer = "OFFER",
}

export enum CancellationFlowEventStateType {
    Accepted = "ACCEPTED",
    Rejected = "REJECTED",
}

export enum CancellationFlowActionType {
    CANCEL = "CANCEL",
    DELAY = "DELAY",
    PAUSE = "PAUSE",
    SKIP_NEXT_ORDER = "SKIP_NEXT_ORDER",
    UPDATE_FREQUENCY = "UPDATE_FREQUENCY",
    CANCELLATION_OFFER = "CANCELLATION_OFFER",
    SWAP_PRODUCT = "SWAP_PRODUCT",
    KEEP_SUBSCRIPTION = "KEEP_SUBSCRIPTION",
    NOT_APPLICABLE = "NOT_APPLICABLE",
    REDEEM_LOYALTY_POINTS = "REDEEM_LOYALTY_POINTS",
    OFFER_LISTING_PAGE = "OFFER_LISTING_PAGE",
    RESCHEDULE = "RESCHEDULE",
    CUSTOM = "CUSTOM",
}

export enum CancellationFlowEventSource {
    CUSTOMER_PORTAL = "CUSTOMER_PORTAL",
    STOREFRONT_API = "STOREFRONT_API",
}

export function getDefaultComponents() {
    return [
        {
            componentType: "STANDARD",
            componentKey: "cpCampaignBanner",
            width: 2,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpUpgradeProfileBanner",
            width: 2,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpPaymentBanners",
            width: 2,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailBackBtn",
            width: 2,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailOverviewHeader",
            width: 2,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailBanners",
            width: 2,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailOrderActions",
            width: 2,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailUpsell",
            width: 2,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailSubscriptionTitle",
            width: 1,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailOrderSchedule",
            width: 1,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailLines",
            width: 2,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailOrderNotes",
            width: 1,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailDiscounts",
            width: 1,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailFrequency",
            width: 1,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailShipping",
            width: 1,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailPaymentMethod",
            width: 1,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailImportantLinks",
            width: 1,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailPauseBtn",
            width: 2,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailCancelBtn",
            width: 2,
        },
        {
            componentType: "STANDARD",
            componentKey: "cpSubscriptionDetailActivateBtns",
            width: 2,
        },
    ];
}

export function getAdditionalClassesForGridItems(key: string) {
    if (!key) {
        return "";
    }
    const _gridKeyClasses = {
        cpSubscriptionDetailBackBtn: "",
        cpSubscriptionDetailOverviewHeader: "",
        cpSubscriptionDetailBanners: "",
        cpSubscriptionDetailOrderActions: "",
        cpSubscriptionDetailUpsell: "mx-n2 mx-md-0",
        cpSubscriptionDetailSubscriptionTitle: "py-0 py-md-2",
        cpSubscriptionDetailOrderSchedule: "py-0 py-md-2 d-flex justify-content-md-end",
        cpSubscriptionDetailLines: "",
        cpSubscriptionDetailOrderNotes: "d-flex",
        cpSubscriptionDetailDiscounts: "d-flex",
        cpSubscriptionDetailFrequency: "d-flex",
        cpSubscriptionDetailShipping: "d-flex",
        cpSubscriptionDetailPaymentMethod: "d-flex",
        cpSubscriptionDetailImportantLinks: "d-flex",
        cpSubscriptionDetailPauseBtn: "d-flex justify-content-center pt-3 pb-1",
        cpSubscriptionDetailCancelBtn: "d-flex justify-content-center pb-3",
        cpSubscriptionDetailActivateBtns: "d-flex justify-content-center pt-3 pb-1",
        cpCampaignBanner: "",
        cpUpgradeProfileBanner: "",
        cpPaymentBanners: "",
    };

    return _gridKeyClasses[key] || "";
}

export const provinceNameToCode = {
    CALIFORNIA: "CA",
};

export enum RewardClaimBehaviour {
    ONLY_WHEN_CLAIMED = "ONLY_WHEN_CLAIMED",
    ALWAYS = "ALWAYS",
}

export enum MysteryRewardTypes {
    AddMysteryRewardOnce = "addMysteryRewardOnce",
    AddMysteryGiftDiscount = "addMysteryGiftDiscount",
}

export enum LoopDiscountType {
    PERCENTAGE = "PERCENTAGE",
    FIXED_AMOUNT = "FIXED_AMOUNT",
}

export enum LoyaltyPointsRedeemEntity {
    LOYALTY_WIDGET = "LOYALTY_WIDGET",
    CANCELLATION_REASON = "CANCELLATION_REASON",
    QUICK_ACTION = "QUICK_ACTION",
    CAMPAIGN_ACTION = "CAMPAIGN_ACTION",
    UPSELL = "UPSELL",
}

export enum CampaignActionTypes {
    UPDATE_PAYMENT_METHOD = "updatePaymentMethod",
    CHARGE_ORDER = "chargeOrder",
    ADD_PRODUCT = "addProduct",
    REACTIVATE_SUBSCRIPTION = "reactivateSubscription",
    RESUME_SUBSCRIPTION = "resumeSubscription",
    SWAP_PRODUCT = "swapProduct",
    LOGIN = "generateSubscriptionLinks",
    MYSTERY_REWARD = "mysteryRewards",
}

export enum CampaignCompletionChannel {
    CUSTOMER_PORTAL = "CUSTOMER_PORTAL",
    CAMPAIGN_ACTION_URL = "CAMPAIGN_ACTION_URL",
}

export const campaignWithUsageLimitEnabled = ["addProduct", "chargeOrder"];

export const INTEGRATION_UNAVAILABLE = 0;
export const INTEGRATION_DISCONNECTED = 1;
export const INTEGRATION_CONNECTED = 2;

export const ContractDeliveryMethods = {
    SHIPPING: "SHIPPING",
    LOCAL_DELIVERY: "LOCAL_DELIVERY",
    PICKUP: "PICKUP",
} as const;
